import { render, staticRenderFns } from "./CategoryListAddNew.vue?vue&type=template&id=7f519f88&"
import script from "./CategoryListAddNew.vue?vue&type=script&lang=js&"
export * from "./CategoryListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./CategoryListAddNew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports